import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneReferendum2025 extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio2025 = "/elezioni/withub/electionday-2025/referendum/" + regione + "/" + regione + ".html";
    let repoFascione2025 = "/elezioni/withub/electionday-2025/referendum/fascione-elezioni.html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione2025} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio2025} />
    </div>
    )
  }
}

export default withParams(RegioneReferendum2025)
